import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UpdateAppOnboardingStatusModalUI from './UpdateAppOnboardingStatusModalUI.js'

class UpdateAppOnboardingStatusModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      appOnboardingStatus: this.props.account.appOnboardingStatus || '',
      appOnboardingStatusList: [],
      appOnboardingStatusError: null
    }
  }

  render() {
    return (
      <UpdateAppOnboardingStatusModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        appOnboardingStatus={this.state.appOnboardingStatus}
        onAppOnboardingStatusChange={this.onAppOnboardingStatusChange}
        appOnboardingStatusList={this.state.appOnboardingStatusList}
        appOnboardingStatusError={this.state.appOnboardingStatusError}
        setAppOnboardingStatusError={(error) => { this.setState({ appOnboardingStatusError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
    this.getAppOnboardingStatuses(context)
  }

  componentDidUpdate(prevProps) {
    if (this.props.updateMode && !prevProps.updateMode) {
      this.setState({
        successMsg: null,
        errorList: null,
        submitted: false,
        appOnboardingStatus: this.props.account.appOnboardingStatus || ''
      })
    }
  }

  getAppOnboardingStatuses(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/superusers/appOnboardingStatus`,
      cacheKey: CacheKeys.SuperUserAppOnboardingStatus(),
      callback: this.getAppOnboardingStatusesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAppOnboardingStatusesCallback = (response) => {
    const toKeyValue = (item) => {
      if (item == null)
        return null

      if (typeof item === 'string') {
        return { key: item, value: item, original: item }
      }

      let key = null
      if (item.key !== undefined) key = item.key
      else if (item.code !== undefined) key = item.code
      else if (item.status !== undefined) key = item.status
      else if (item.statusCode !== undefined) key = item.statusCode
      else if (item.statusKey !== undefined) key = item.statusKey
      else if (item.value !== undefined) key = item.value
      else if (item.name !== undefined) key = item.name
      else if (item.label !== undefined) key = item.label
      else if (item.statusId !== undefined) key = item.statusId

      let value = null
      if (item.value !== undefined) value = item.value
      else if (item.name !== undefined) value = item.name
      else if (item.label !== undefined) value = item.label
      else if (item.statusName !== undefined) value = item.statusName
      else if (item.statusValue !== undefined) value = item.statusValue
      else if (item.display !== undefined) value = item.display
      else value = key

      if (key === undefined || key === null)
        return null

      return { key, value }
    }

    const candidateLists = [
      response.appOnboardingStatusList,
      response.statusList,
      response.keyValueList,
      response.list,
      response.appOnboardingStatusKeyValueList,
      response.appOnboardingStatus,
      Array.isArray(response) ? response : null
    ].filter((list) => Array.isArray(list) && list.length)

    let sourceList = candidateLists.length ? candidateLists[0] : null

    if (!sourceList && response && typeof response === 'object') {
      sourceList = Object.values(response).find((value) => Array.isArray(value) && value.length)
    }

    let appOnboardingStatusList = []

    if (sourceList) {
      appOnboardingStatusList = sourceList
        .map(toKeyValue)
        .filter((item) => item && item.key !== undefined && item.key !== null)
    }

    this.setState((prevState) => {
      const preferredKey = prevState.appOnboardingStatus || this.props.account.appOnboardingStatus
      const hasPreferred = appOnboardingStatusList.some(item => item.key === preferredKey)

      return {
        errorList: response.errorList,
        appOnboardingStatusList,
        appOnboardingStatus: hasPreferred
          ? preferredKey
          : (appOnboardingStatusList.length ? appOnboardingStatusList[0].key : '')
      }
    })
  }

  onAppOnboardingStatusChange = (event) => {
    const value = event.target.value
    this.setState({
      appOnboardingStatus: value
    })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    const context = this.props.context
    const statusParam = this.state.appOnboardingStatus

    RestApiUtils.put(
      context,
      `/api/su/accounts/${this.props.account.accountId}/updateAppOnboardingStatus?status=${encodeURIComponent(statusParam)}`,
      this.onSubmitCallback,
      {}
    )
  }

  onSubmitCallback = (response) => {
    const responseErrorList = (response && Array.isArray(response.errorList)) ? response.errorList : []
    const errorList = responseErrorList.map((error) => error && error.message ? error.message : error)

    this.setState({
      successMsg: response ? response.success : null,
      errorList: errorList,
      submitted: false
    })

    if (responseErrorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 20)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default UpdateAppOnboardingStatusModalSF

